import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { PriceListEnums } from 'src/app/enum/price-list-enums';
import { PriceListModel } from 'src/app/models/archive/price-list.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { BranchEnums } from './../../../../enum/branch-enums';
import { PriceListService } from './../../../../services/archive/price-list.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-register-price-list',
  templateUrl: './register-price-list.component.html',
  styleUrls: ['./register-price-list.component.scss'],
  standalone: false
})
export class RegisterPriceListComponent implements OnInit, OnDestroy {

  branchId: number = 0;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  formPriceList: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listBranch: any[] = [];
  listType = BranchEnums.sucursalesUsuario;
  mainBranchByUser: BranchModel = new BranchModel();
  nameWindow: string = 'Captura Listas de Precios';
  permissionUpdatable: boolean = false;
  priceListContract: PriceListModel = new PriceListModel();
  priceListId: number = 0;
  projectName = ProjectName.projectName;
  url: string = 'price-list';

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private location: Location,
    private priceListService: PriceListService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(this.priceListContract);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.priceListId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  changeBranch() {
    this.branchId = this.formPriceList.get("branchId")?.value;
    this.priceListId = 0;
    this.priceListContract = new PriceListModel();
    this.priceListContract.branchId = this.branchId;
    this.validateForm(this.priceListContract);
  }

  async changeCode() {
    this.branchId = this.formPriceList.get("branchId")?.value;
    let code = this.formPriceList.get("code")?.value;

    if (this.branchId === null || this.branchId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        "Seleccione una sucursal."
      );
      return;
    } else if (code <= 0) {
      code = null;
    }

    if (code == null) {
      this.createNewPriceList();
    } else {
      try {
        this.priceListContract = await firstValueFrom(
          this.priceListService.getPriceListByCodeAsync(this.branchId, code)
        );
        this.priceListId = this.priceListContract.priceListId;
        this.branchId = this.priceListContract.branchId;
        this.validateForm(this.priceListContract);
        this.location.replaceState(`/${this.url}/register/${this.priceListId}`);
      } catch (error) {
        this.createNewPriceList();
        console.error('Error al obtener la lista de precios por código:', error);
      }
    }
  }

  createNewPriceList() {
    this.priceListId = 0;
    this.branchId = this.mainBranchByUser.branchId;
    this.priceListContract = new PriceListModel();
    this.priceListContract.branchId = this.branchId;
    this.validateForm(this.priceListContract);
    this.disabledDetail = true;
    this.disabledForm = false;
    this.location.replaceState(`/${this.url}/register`);
  }

  async deletePriceList() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para eliminar listas de precios. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    if (this.priceListContract.priceListId == 0 || this.priceListContract.priceListId == null) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una lista de precios.'
      );
      return;
    }

    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar la lista de precios actual?')) {
      try {
        await firstValueFrom(this.priceListService.deletePriceList(this.priceListId));
        this.createNewPriceList();
        this.toastHandlerService.showToast(
          'success',
          'La lista de precios fue eliminada exitosamente.'
        );
      } catch (error) {
        console.error("Error al eliminar la lista de precios.", error);
      }
    }
  }

  async getAllBranchesForSelect() {
    try {
      this.listBranch = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
    } catch (error) {
      console.error('Error al obtener las sucursales para el select.', error);
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    if (branchId == null || branchId === 0) {
      this.formPriceList.controls["branchId"].setValue(0);
    }
    if (reload) {
      this.changeBranch();
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formPriceList.get("branchId")?.value;
    let code = this.formPriceList.get("code")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        "Seleccione una sucursal."
      );
      return;
    }

    if (code == null || code <= 0) {
      code = 0;
    }

    await this.handlePriceListNavigation(buttonClick, branchId, code);
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      this.mainBranchByUser = await firstValueFrom(
        this.userAuthenticatedService.branchObservable.pipe(filter(branch => branch && branch.branchId !== 0))
      );
      this.branchId = this.mainBranchByUser.branchId;
      await this.getBranch(this.mainBranchByUser.branchId, false);
    } catch (error) {
      console.error('Error al consultar la primera sucursal del usuario autenticado:', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getFirstBranchByUserAuthenticated(),
      this.getPermissionProfileByUrl(),
      this.getAllBranchesForSelect(),
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al obtener los permisos de la ventana.', error);
    }
  }

  async getPriceListById() {
    try {
      this.priceListContract = await firstValueFrom(this.priceListService.getPriceListById(this.priceListId));
      this.branchId = this.priceListContract.branchId;
      this.priceListId = this.priceListContract.priceListId;
      this.validateForm(this.priceListContract);
      this.location.replaceState(`/${this.url}/register/${this.priceListId}`);
    } catch (error) {
      console.error('Error al obtener la lista de precios por ID:', error);
    }
  }

  async handleInitialState() {
    if (this.priceListId != null && this.priceListId !== 0) {
      await this.getPriceListById();
    } else {
      this.createNewPriceList();
    }
  }

  async handlePriceListNavigation(buttonClick: any, branchId: number, code: number) {
    const actionMap: Record<string, () => Promise<PriceListModel>> = {
      first: async () =>
        await firstValueFrom(this.priceListService.getFirstPriceListByKeysAsync(branchId)),
      previus: async () =>
        await firstValueFrom(this.priceListService.getPreviusPriceListByKeysAsync(branchId, code)),
      next: async () =>
        await firstValueFrom(this.priceListService.getNextPriceListByKeysAsync(branchId, code)),
      last: async () =>
        await firstValueFrom(this.priceListService.getLastPriceListByKeysAsync(branchId)),
    };

    const action = actionMap[buttonClick.target.id];
    if (!action) return;

    try {
      const priceList = await action();
      this.priceListId = priceList.priceListId;
      this.priceListContract = priceList;
      this.validateForm(this.priceListContract);
      this.location.replaceState(`/${this.url}/register/${this.priceListId}`);
    } catch (error) {
      console.error(`Error al buscar la lista de precios (${buttonClick.target.id}).`, error);
    }
  }

  async send() {
    this.validateFormControls();
    if (!this.formPriceList.valid) {
      this.showValidationMessages();
      return;
    }
    const modelPriceList = this.formPriceList.getRawValue() as PriceListModel;
    if (modelPriceList.alterCode?.trim() === "") modelPriceList.alterCode = null;
    if (modelPriceList.observation?.trim() === "") modelPriceList.observation = null;

    if (this.priceListId === 0) {
      try {
        this.priceListContract = await firstValueFrom(
          this.priceListService.createPriceList(modelPriceList)
        );
        this.priceListId = this.priceListContract.priceListId;
        this.validateForm(this.priceListContract);
        this.location.replaceState(`/${this.url}/register/${this.priceListId}`);
        this.toastHandlerService.showToast(
          'success',
          'La lista de precios fue creada exitosamente.'
        );
      } catch (error) {
        console.error('Error al crear la lista de precios:', error);
      }
    } else {
      this.priceListContract.alterCode = modelPriceList.alterCode;
      this.priceListContract.name = modelPriceList.name;
      this.priceListContract.rateDiscount = modelPriceList.rateDiscount;
      this.priceListContract.observation = modelPriceList.observation;

      try {
        this.priceListContract = await firstValueFrom(
          this.priceListService.updatePriceList(this.priceListContract)
        );
        this.priceListId = this.priceListContract.priceListId;
        this.validateForm(this.priceListContract);
        this.location.replaceState(`/${this.url}/register/${this.priceListId}`);
        this.toastHandlerService.showToast(
          'success',
          'La lista de precios fue modificada exitosamente.'
        );
      } catch (error) {
        console.error('Error al actualizar la lista de precios.', error);
      }
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      code: {
        required: 'El campo Código es obligatorio.',
        min: 'Debe ingresar un Código igual o superior a Cero (0).'
      },
      alterCode: {
        maxlength: 'El campo Código Alterno no puede tener más de 10 caracteres.'
      },
      name: {
        required: 'El campo Nombre es obligatorio.',
        maxlength: 'El campo Nombre no puede tener más de 70 caracteres.'
      },
      rateDiscount: {
        required: 'El campo Descuento es obligatorio.',
        min: 'No puede ingresar un valor menor a -9999.99 en el campo Descuento.',
        max: 'No puede ingresar un valor mayor a 9999.99 en el campo Descuento.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formPriceList.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateFormState() {
    if (this.permissionUpdatable) {
      this.disabledForm = false;
      setTimeout(() => this.formPriceList.enable(), 100);
      if (this.priceListContract.priceListId !== 0 && this.priceListContract.priceListId != null) {
        this.disabledDetail = false;
      } else {
        setTimeout(() => this.formPriceList.controls["code"].disable(), 100);
      }
    } else {
      this.disabledDetail = true;
      this.disabledForm = true;
      setTimeout(() => this.formPriceList.disable(), 100);
      setTimeout(() => this.formPriceList.controls["branchId"].enable(), 100);
      setTimeout(() => this.formPriceList.controls["code"].enable(), 100);
    }
    if (this.priceListContract.code === PriceListEnums.base) {
      setTimeout(() => this.formPriceList.controls["rateDiscount"].disable(), 100);
    } else {
      setTimeout(() => this.formPriceList.controls["rateDiscount"].enable(), 100);
    }
  }

  validateForm(priceList: PriceListModel) {
    this.formPriceList = this.formBuilder.group({
      branchId: [priceList.branchId, [Validators.required, Validators.min(1)]],
      code: [priceList.code, [Validators.required, Validators.min(0)]],
      alterCode: [priceList.alterCode, [Validators.maxLength(10)]],
      name: [priceList.name, [Validators.required, Validators.maxLength(70)]],
      rateDiscount: [priceList.rateDiscount, [Validators.required, Validators.min(-9999.99), Validators.max(9999.99)]],
      observation: [priceList.observation, [Validators.maxLength(250)]]
    });
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formPriceList.controls).forEach((key) => {
      const control = this.formPriceList.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
